import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {Loner} from "../Loner";
import {SimplePresentation, SimplePresentationRunner} from "../../core/winpresentation/SimplePresentationRunner";
import {LonerNormalSpinPresentation} from "../presentationrunners/LonerNormalSpinPresentation";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";
import {LonerSound} from "../sound/LonerSound";
import {LonerTVMessageView} from "../view/general/LonerTVMessageView";
import {MathHelper} from "@nolimitcity/slot-game/bin/utils/MathHelper";

/**
 * Created by Jerker Nord on 2021-01-28.
 */

export class LonerNormalBetTrigger implements FlowStatePresentation {

    private readonly _presentations: SimplePresentation[];
    private _flowStateController: FlowStateController;
    private _lastGMLoopSoundIdx: number = 3;

    constructor() {
        Loner.apiPlugin.events.on(APIEvent.BET, (betData: any) => {
            if (betData && betData.playerInteraction && betData.playerInteraction.featureName === "GOD_MODE") {
                let randomNumber: number = 0;
                while (this._lastGMLoopSoundIdx === randomNumber) {
                    randomNumber = MathHelper.randomIntInRange(0, 3);
                }
                this._lastGMLoopSoundIdx = randomNumber;
                Loner.soundPlayer.playSound(LonerSound.GM_LOOP_SOUNDS[this._lastGMLoopSoundIdx], 1, Number.MAX_VALUE);
                Loner.soundPlayer.playSound(LonerSound.GM_START_SOUND);
                Loner.soundPlayer.fadeMusic(1, 0, 0.001);
                Loner.isGodModeRound=true;
            }
        })
        this._presentations = [
            new LonerNormalSpinPresentation()
        ]
    }

    public start(flowStateController: FlowStateController): void {
        this._flowStateController = flowStateController;

        Loner.individualWin.stop();

        Loner.initialWinView.resetWinContainers();
        Loner.winWaysView.reset();
        Loner.tvMessageView.checkStartTVMessage();

        SimplePresentationRunner.run(this._presentations, () => this.complete(), (callback?: Function) => flowStateController.setSkipCallback(callback));
    }

    public complete(): void {
        this._flowStateController.finish();
    }
}